import client from "../request"

const getAll = () => {
  return client.get(`/settings`)
}

const get = (id) => {
  return client.get(`/settings/${id}`)
}

export default {
  getAll,
  get,
}
